import { useState, useEffect } from "react";
import { FaCircle, FaCheck, FaCheckCircle } from "react-icons/fa";
import { APIURL } from "../../../configApi/apiConfig";
import axios from "../../../configApi/axiosConfig";
import { useAuth } from "../../AuthContext/AuthContext"
import Filtros from "../Filtros"
import { ResumenGestion } from "../ResumenGestion";

const getVendidoIcon = (Estado) => {
	if (Estado === null || Estado === undefined)
		return <FaCircle className="text-gray-400 text-xl mx-auto" title="Sin gestión" />;
	if (Estado === 3)
		return <FaCheckCircle className="text-emerald-400 text-xl mx-auto" title="Vendido" />;
	return <FaCircle className="text-rose-500 text-xl mx-auto" title="No vendido" />;
};

const formatDate = (dateStr) => {
	if (!dateStr) return "—";
	const d = new Date(dateStr);
	return d.toLocaleDateString("es-EC", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
};

const EstadoModal = ({ row, resultados, onClose, onAsignar }) => {
	const [selected, setSelected] = useState(row.idResultadoGestion ?? "");

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center">

			<div
				className="absolute inset-0 bg-slate-200/40 backdrop-blur-sm"
				onClick={onClose}
			/>

			{/* Panel */}
			<div
				className="relative z-10 rounded-2xl shadow-xl w-full max-w-sm mx-4 overflow-hidden border border-slate-200"
				style={{
					background: "linear-gradient(145deg, #ffffff, #f1f5ff)",
				}}
			>
				{/* Header */}
				<div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
					<div>
						<p className="text-xs text-indigo-500 font-semibold tracking-widest uppercase mb-0.5">
							Gestión de Estado
						</p>
						<p className="text-slate-800 font-bold text-sm truncate max-w-[200px]">
							{row.Nombres}
						</p>
					</div>
				</div>

				{/* Body */}
				<div className="px-6 py-6">
					<label className="block text-slate-600 text-xs font-semibold tracking-widest uppercase mb-2">
						Resultado de Gestión
					</label>
					<select
						value={selected}
						onChange={(e) =>
							setSelected(e.target.value === "" ? "" : Number(e.target.value))
						}
						className="w-full rounded-xl px-4 py-3 text-sm font-medium text-slate-700 outline-none border border-slate-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all bg-white"
					>
						<option value="">
							Selecciona una opción
						</option>
						{resultados.map((r) => (
							<option
								key={r.idResultadoGestion}
								value={r.idResultadoGestion}
							>
								{r.Descripcion}
							</option>
						))}
					</select>
				</div>

				{/* Footer */}
				<div className="px-6 pb-6 flex gap-3">
					<button
						onClick={onClose}
						className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-slate-600 border border-slate-300 hover:bg-slate-100 transition-colors"
					>
						Cerrar
					</button>

					<button
						onClick={() => {
							onAsignar(selected);
						}}
						className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-all"
						style={{
							background: "linear-gradient(135deg, #4f5ef7, #6366f1)",
							boxShadow: "0 4px 14px rgba(79,94,247,0.25)",
						}}
					>
						<FaCheck className="text-xs" />
						Asignar
					</button>
				</div>
			</div>
		</div>
	);
};


export const RescateClientes = () => {

	const { userData } = useAuth();
	const [clientes, setClientes] = useState([]);
	const [resultados, setResultados] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalRow, setModalRow] = useState(null);

	const fetchClientes = async (codigo, fechaDesde, fechaHasta, filtro = "",idResultadoGestion = "") => {
		try {
			const params = {};

			if (fechaDesde && fechaHasta) {
				params.fechaDesde = fechaDesde;
				params.fechaHasta = fechaHasta;
			}

			if (filtro) params.filtro = filtro;
			if (idResultadoGestion !== "") params.idResultadoGestion = idResultadoGestion;

			const response = await axios.get(APIURL.getClientesRescatados(codigo),
				{ params }
			);
			if (response.status === 200) {
				const solicitudes = response.data;
				setClientes(solicitudes);
			}
		} catch (error) {
			console.error("Error fetching clientes data:", error);
		}
	};

	const fetchResultados = async () => {
		try {
			const response = await axios.get(APIURL.getResultadosgestion());
			if (response.status === 200) {
				setResultados(response.data);
			}
		} catch (error) {
			console.error("Error fetching resultados:", error);
		}
	};

	const patchResultadoRescate = async (sCre_SolicitudWeb, idResultadoGestion) => {
		try {
			const response = await axios.patch(APIURL.patchResultadoRescate(), {
				sCre_SolicitudWeb,
				idResultadoGestion,
			});
			return response.data;
		} catch (error) {
			console.error("Error actualizando resultado", error);
			throw error;
		}
	};

	useEffect(() => {
		const init = async () => {
			setLoading(true);
			await Promise.all([fetchClientes(userData?.Nombre), fetchResultados()]);
			setLoading(false);
		};
		init();
	}, []);

	const handleBuscar = (fechaDesde, fechaHasta, filtro = "", idResultadoGestion = "") => {
		fetchClientes(userData?.Nombre, fechaDesde, fechaHasta, filtro, idResultadoGestion);
	};

	const handleAsignar = async (idResultado) => {
		setClientes((prev) =>
			prev.map((c) =>
				c.idCre_RescateClientes === modalRow.idCre_RescateClientes
					? { ...c, idResultadoGestion: idResultado === "" ? null : idResultado }
					: c
			)
		);

		try {
			await patchResultadoRescate(modalRow.sCre_SolicitudWeb, idResultado === "" ? null : idResultado);
			console.log("Resultado actualizado correctamente en la BDD");
		} catch (error) {
			console.error("Error al actualizar resultado:", error);
		}


		setModalRow(null);
	};

	const getEstadoLabel = (idResultadoGestion) => {
		if (!idResultadoGestion) return "Sin gestión";
		const r = resultados.find((r) => r.idResultadoGestion === idResultadoGestion);
		return r ? r.Descripcion : "Desconocido";
	};

	const getEstadoBadgeStyle = (idResultadoGestion) => {
		if (idResultadoGestion === null || idResultadoGestion === undefined)
			return "bg-gray-700/60 text-gray-400 border-gray-600";
		if (idResultadoGestion === 4 || idResultadoGestion === 6)
			return "bg-emerald-500/20 text-emerald-300 border-emerald-500/40";
		return "bg-rose-500/20 text-rose-300 border-rose-500/40";
	};

	return (
		<>
			<div
				className="min-h-screen px-4 py-8"
				style={{ background: "#0f1235" }}
			>
				<div className="max-w-[1400px] mx-auto mb-8">
					<div className="flex items-center gap-3 mb-1">
						<div
							className="w-1 h-8 rounded-full"
							style={{ background: "linear-gradient(to bottom, #4f5ef7, #2D3689)" }}
						/>
						<h1
							className="text-2xl font-bold tracking-tight"
							style={{
								color: "#fff",
								fontFamily: "'DM Sans', sans-serif",
							}}
						>
							Rescate de Clientes
						</h1>
					</div>
				</div>

				<Filtros onBuscar={handleBuscar} loading={loading} resultados={resultados} />
				<ResumenGestion clientes={clientes} resultados={resultados} />



				<div
					className="max-w-[1400px] mx-auto rounded-2xl overflow-hidden border border-white/10"
					style={{
						background: "linear-gradient(145deg, #161a4a, #1e2460)",
						boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
					}}
				>
					{loading ? (
						<div className="flex items-center justify-center py-24">
							<div
								className="w-10 h-10 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin"
							/>
							<span className="ml-4 text-indigo-300 text-sm">Cargando clientes…</span>
						</div>
					) : (
						<div className="overflow-x-auto">
							<table className="w-full text-sm">
								<thead>
									<tr
										style={{
											background: "rgba(45, 54, 137, 0.8)",
											borderBottom: "1px solid rgba(255,255,255,0.08)",
										}}
									>
										{[
											{ name: "Agencia", width: "w-24" },
											{ name: "Fecha Consulta", width: "w-24" },
											{ name: "Cédula", width: "w-28" },
											{ name: "Cliente", width: "w-auto" },
											{ name: "Celular", width: "w-24" },
											{ name: "Producto", width: "w-24" },
											{ name: "Cuota", width: "w-20" },
											{ name: "Estado", width: "w-40" },
											{ name: "Vendido", width: "w-16" },
										].map((col) => (
											<th
												key={col.name}
												className={`px-4 py-3 text-left text-xs font-bold uppercase tracking-widest whitespace-nowrap ${col.width}`}
												style={{ color: "rgba(165,178,255,0.85)" }}
											>
												{col.name}
											</th>
										))}
									</tr>
								</thead>
								<tbody>
									{clientes.length === 0 ? (
										<tr>
											<td
												colSpan={9}
												className="text-center py-16 text-indigo-400 text-sm"
											>
												No hay clientes registrados.
											</td>
										</tr>
									) : (
										clientes.map((c, i) => (
											<tr
												key={c.idCre_RescateClientes}
												className="border-b border-white/5 transition-colors hover:bg-white/5"
												style={{
													background:
														i % 2 === 0
															? "transparent"
															: "rgba(255,255,255,0.02)",
												}}
											>
												{/* Agencia */}
												<td className="px-4 py-3 text-indigo-200 whitespace-nowrap font-medium">
													{c.nombreBodega || "—"}
												</td>

												{/* Fecha Consulta */}
												<td className="px-4 py-3 text-indigo-300 whitespace-nowrap">
													{formatDate(c.FechaSolicitud)}
												</td>

												{/* Cédula */}
												<td className="px-4 py-3 text-indigo-200 whitespace-nowrap font-mono tracking-wider">
													{c.Cedula}
												</td>

												{/* Cliente */}
												<td className="px-4 py-3 text-white font-medium max-w-[180px] truncate">
													{c.Nombres}
												</td>

												{/* Celular */}
												<td className="px-4 py-3 text-indigo-300 whitespace-nowrap font-mono">
													{c.Celular}
												</td>

												{/* Producto */}
												<td className="px-4 py-3 text-indigo-200 whitespace-nowrap">
													{c.nombreProducto || "—"}
												</td>

												{/* Cuota */}
												<td className="px-4 py-3 text-white font-semibold whitespace-nowrap">
													${c.CuotaAsignada?.toLocaleString("es-EC")}
												</td>

												{/* Estado */}
												<td className="px-4 py-3">
													<button
														onClick={() => setModalRow(c)}
														className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold tracking-wide transition-all hover:brightness-125 hover:scale-105 active:scale-95 ${getEstadoBadgeStyle(
															c.idResultadoGestion
														)}`}
													>
														<FaCircle className="text-[6px]" />
														{getEstadoLabel(c.idResultadoGestion)}
													</button>
												</td>

												{/* Vendido */}
												<td className="px-4 py-3 text-center">
													{getVendidoIcon(c.Estado)}
												</td>
											</tr>
										))
									)}
								</tbody>
							</table>
						</div>
					)}
				</div>

			</div>

			{/* Modal */}
			{modalRow && (
				<EstadoModal
					row={modalRow}
					resultados={resultados}
					onClose={() => setModalRow(null)}
					onAsignar={handleAsignar}
				/>
			)}
		</>
	)
}
